// Which i18n key an auth failure should be SHOWN as, or null to fall back to
// whatever the identity provider said.
//
// ⚠️ Exists because `auth.signInFailed` was, on its own, a dead branch. Both
// surfaces render `err.message ?? t("auth.signInFailed")`, and both build that
// error through a `toAuthError` that already defaults `message` to a string
// (apps/web-rnw/src/auth/cognito.ts:56, apps/mobile/src/auth/cognito.ts:64) —
// so the `??` can never fire and the athlete always reads Cognito's own copy.
// Measured in a real browser on the served build, not deduced: a wrong password
// announces "Incorrect username or password." in English, on the one screen an
// athlete who reads in French sees first.
//
// ⛔ Deliberately NOT a full code→copy table. Only the two codes that mean "that
// pair did not authenticate" are mapped, and they map to the SAME string on
// purpose: telling the two apart would let the page enumerate which addresses
// have an account. Every other code (unconfirmed user, expired password, rate
// limit) still shows the provider's message, still in English — that is a real
// residue with its own backlog voice, not something this helper silently
// pretends to have covered.
const CREDENTIAL_FAILURE_CODES = new Set([
  "NotAuthorizedException",
  "UserNotFoundException",
]);

export const signInErrorKey = (code: string | undefined): string | null =>
  code !== undefined && CREDENTIAL_FAILURE_CODES.has(code)
    ? "auth.signInFailed"
    : null;
